"use client";

import { Toast } from "@/components/Toast";
import api from "@/helper/api.interceptor";
import {
  setInquiryPopupObj,
  setThankYouData,
} from "@/store/slices/inquirySlice";
import { useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useNavigate, useParams } from "react-router";
// import Seo from "../components/Seo";
// import { CountryList } from "../services/CountryList";
// import { toast } from "react-toastify";

export default function ChannelPartner({ channelPartnerData, pageList }) {
  const dispatch = useDispatch();
  const router = useRouter();
  //   const [channelPartnerData, setchannelPartnerData] = useState(
  //     ChannelDetail || null
  //   );
  const [isMobilescreen, setMobilescreen] = useState(false);
  const [inquiryObj, setInquiryObj] = useState({
    name: "",
    contact_no_display: "",
    contact_no: "",
    email_address: "",
    birth_date_display: "",
    company_name: "",
    from_app: "true",
    master_user_id: "373",
    logged_in_master_user_id: "373",
    address: "",
    inquiry_from: "web",
    associated_company: false,
    company_id: "",
    is_crown: "0",
    flag: "https://flagcdn.com/w40/in.webp",
    country: "91",
  });

  const todayDate = new Date().toISOString().split("T")[0];
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [countryFlag, setCountryFlag] = useState(false);
  // const [countryList, setCountryList] = useState([]);
  const [search, setSearch] = useState("");
  const [errors, setErrors] = useState({});

  const countryList = useSelector((state) => state.inquiry.countryList);

  //   const seoMetaData = channelPartnerData && {
  //     page_title:
  //       channelPartnerData.seo_title ||
  //       " Become a Channel Partner | Swati Procon",
  //     page_description: channelPartnerData.seo_description,
  //     page_keywords: channelPartnerData.seo_keywords,
  //     slug: channelPartnerData.slug,
  //     image: channelPartnerData.seo_image_full
  //       ? channelPartnerData.seo_image_full.includes("?")
  //         ? `${channelPartnerData.seo_image_full}&w=1280&h=640`
  //         : `${channelPartnerData.seo_image_full}?w=1280&h=640`
  //       : "/images/sswati-procon.png",
  //   };

  useEffect(() => {
    // async function loadCountry() {
    //   try {
    //     const data = await api.CountryList();
    //     // console.log(data);
    //     const filtered = data.filter((c) => c.phonecode !== "92");
    //     setCountryList(filtered);
    //   } catch (error) {
    //     console.error("Error loading countries", error);
    //   }
    // }
    // loadCountry();
  }, []);

  const validate = () => {
    let newErrors = {};
    const nameRegex = /^[a-zA-Z\s]+$/;
    const phoneRegex = /^\d{10}$/;
    const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;

    if (!inquiryObj.name.trim()) {
      newErrors.name = "Name is required";
    } else if (!nameRegex.test(inquiryObj.name)) {
      newErrors.name = "Name must contain only letters";
    }

    if (!inquiryObj.contact_no_display.trim()) {
      newErrors.contact_no_display = "Contact number is required";
    } else if (!phoneRegex.test(inquiryObj.contact_no_display)) {
      newErrors.contact_no_display = "Contact number must be 10 digits";
    }

    if (!inquiryObj.email_address.trim()) {
      newErrors.email_address = "Email is required";
    } else if (!emailRegex.test(inquiryObj.email_address)) {
      newErrors.email_address = "Invalid email format";
    }

    if (!inquiryObj.address || inquiryObj.address.trim() === "") {
      newErrors.address = "Address is required";
    }

    if (!inquiryObj.birth_date_display) {
      newErrors.birth_date_display = "Date of birth is required";
    } else if (new Date(inquiryObj.birth_date_display) > new Date()) {
      newErrors.birth_date_display = "Date of birth cannot be in the future";
    }

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;
    setFormSubmitted(false);

    if (name === "name") {
      updatedValue = value.replace(/[0-9]/g, "");
    }
    if (name === "contact_no_display") {
      updatedValue = value.replace(/[^0-9]/g, "").slice(0, 10);
    }

    if (name === "email_address") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(updatedValue)) {
        setErrors((prev) => ({
          ...prev,
          email_address: "Invalid email format",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          email_address: "",
        }));
      }
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    setInquiryObj((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleCountrySelect = (phonecode, flag) => {
    setInquiryObj((prev) => ({
      ...prev,
      country: phonecode,
      flag,
    }));
    setCountryFlag(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    // console.log(inquiryObj.birth_date_display);
    // return;
    const first_name = inquiryObj.name.split(" ")[0];
    const birth_date = new Date(inquiryObj.birth_date_display).getTime() / 1000;
    const last_name = inquiryObj.name.split(" ")[1]
      ? inquiryObj.name.split(" ")[1]
      : "";
    const contact_no = inquiryObj.country + " " + inquiryObj.contact_no_display;
    const finalInquiry = {
      ...inquiryObj,
      first_name,
      last_name,
      contact_no,
      birth_date,
    };

    // console.log(finalInquiry);
    // return;

    try {
      const response = await api.ChannelPartnerInquiry(finalInquiry);
      if (response.success == 1) {
        setInquiryObj((prev) => ({
          ...prev,
          name: "",
          contact_no_display: "",
          contact_no: "",
          email_address: "",
          address: "",
          birth_date_display: "",
          company_name: "",
          address: "",
        }));
        setErrors({});

        dispatch(
          setThankYouData({
            page_name: "Channel Partner",
            document: [],
          })
        );
        router.push(`/channelpartner/thankyou`);

        // alert("Inquiry submitted successfully!");
      }
      setFormSubmitted(false);
      Toast(response.message);

      // Reset form
    } catch (err) {
      console.error("Submission error:", err);
      setFormSubmitted(false);
      //   alert("Failed to submit inquiry. Please try again.");
    }
  };

  useEffect(() => {
    // let channelData = {};
    // if (channelPartnerData == null) {
    //   channelData = pageList.find((page) => page.slug == "channelpartner");
    //   setchannelPartnerData(channelData);
    // }

    // console.log(channelPartnerData);
    if (window.innerWidth <= 767) setMobilescreen(true);
    dispatch(setInquiryPopupObj(null));
  }, []);
  return (
    <>
      {/* {seoMetaData && <Seo metaData={seoMetaData} />} */}
      <div className="reecosys-main-wrapper" id="reecosys-main-wrapper">
        <div
          id="reecosys-contact-us-wrapper"
          className="relative inner-flex-big inner-flex"
        >
          <section
            className="reecosys-section relative"
            id="reecosys-contact-us-section-1"
          >
            <div className="common-listing-banner relative">
              <img
                src="https://www.reecosys.com/api/image-tool/index.php?src=https://www.reecosys.com/assets/uploads/pages/banner/banner_1740485226_45.png&w=1920&h=750"
                alt=""
                className="hide-tab-mobile"
              />
              {isMobilescreen && (
                <img
                  src="https://www.reecosys.com/api/image-tool/index.php?src=https://www.reecosys.com/assets/uploads/project/images/gallery_1740494786_6.jpg&h=752&w=964&q=100"
                  className="visible-tab-mobile"
                  alt="Mobile Banner"
                  style={{ height: "unset" }}
                />
              )}
              <div className="common-list-overlay"></div>
            </div>
            <div className="black_overlay "></div>
          </section>

          <section
            className="reecosys-section section-padding-bottom relative"
            id="reecosys-contact-us-section-2"
          >
            <div className="main-container">
              <div className="inner-flex inner-flex-medium">
                <div className="page-list-2-col-grid">
                  <div className="inner-flex inner-flex-medium">
                    <div className="section-title">
                      <h1 className="capitalize">Registration Form</h1>
                    </div>
                    <div className="section-content">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: channelPartnerData.primary_text_display,
                        }}
                      ></p>
                    </div>
                  </div>
                  <div>
                    <form
                      id="inquiry_form_detail"
                      name="inquiry_form_detail"
                      className="inner-flex"
                      onSubmit={handleSubmit}
                    >
                      <div className="form_wrapper contact_form">
                        <div className="contact_lable">
                          <span className="material-symbols-outlined icon-form-control">
                            person
                          </span>
                          <input
                            id="name"
                            name="name"
                            type="text"
                            className={`form-control form-control-iconpad ${
                              inquiryObj.name ? "ng-not-empty" : "ng-empty"
                            } ${errors.name ? "ng-invalid" : "ng-valid"} ${
                              inquiryObj.name ? "ng-touched" : ""
                            } ${formSubmitted && errors.name ? "error" : ""}`}
                            value={inquiryObj.name}
                            onChange={handleChange}
                            tabIndex="1"
                          />
                          <label className="md-lable" htmlFor="name">
                            Name
                          </label>
                          <div className="valid-icon-of-form">
                            <img
                              loading="lazy"
                              src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                              alt="valid"
                            />
                          </div>
                        </div>

                        {/* Contact Number */}
                        <div className="contact_lable relative">
                          <span className="material-symbols-outlined icon-form-control">
                            dialpad
                          </span>
                          <input
                            id="contact_no_display"
                            name="contact_no_display"
                            type="text"
                            className={`form-control contact-form form-control-iconpad ${
                              inquiryObj.contact_no_display
                                ? "ng-not-empty"
                                : "ng-empty"
                            } ${
                              formSubmitted && errors.contact_no_display
                                ? "error"
                                : ""
                            } ${
                              !errors.contact_no_display &&
                              inquiryObj.contact_no_display.length === 10
                                ? "ng-valid"
                                : "ng-invalid"
                            } ${
                              inquiryObj.contact_no_display ? "ng-touched" : ""
                            }`}
                            value={inquiryObj.contact_no_display}
                            onChange={handleChange}
                            minLength="10"
                            maxLength="10"
                            tabIndex="2"
                          />
                          <label
                            className="md-lable contact_code"
                            htmlFor="contact_no_display"
                          >
                            Mobile Number
                          </label>
                          <div className="valid-icon-of-form">
                            <img
                              loading="lazy"
                              src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                              alt="valid"
                            />
                          </div>
                          <div className="conatct_number_input">
                            <div
                              className="country_code_data"
                              onClick={(e) => {
                                setCountryFlag(true);
                                e.stopPropagation();
                              }}
                            >
                              <div className="contact_country_flag">
                                <img
                                  loading="lazy"
                                  src={inquiryObj.flag}
                                  alt="country-flag"
                                />
                              </div>
                              <div>&nbsp;+{inquiryObj.country}</div>
                              <div>
                                <i
                                  className="fa fa-angle-down"
                                  aria-hidden="true"
                                ></i>
                              </div>
                            </div>
                          </div>

                          {countryFlag && (
                            <div
                              className="country-overlay"
                              onClick={() => {
                                setCountryFlag(false);
                              }}
                            ></div>
                          )}
                          <div
                            className={`country_code_list_data ${
                              countryFlag ? "active" : ""
                            }`}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="search_c-code">
                              <input
                                type="text"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                placeholder="Search"
                              />
                            </div>
                            <ul>
                              {countryList
                                .filter(
                                  (item) =>
                                    item.phonecode
                                      .toString()
                                      .includes(search) ||
                                    item.nicename
                                      .toLowerCase()
                                      .includes(search.toLowerCase())
                                )
                                .map((item, index) => (
                                  <li
                                    key={`${item.phonecode}-${item.nicename}-${index}`}
                                  >
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleCountrySelect(
                                          item.phonecode,
                                          item.flag
                                        );
                                      }}
                                    >
                                      <div>
                                        <img src={item.flag} alt="country" />
                                      </div>
                                      <span className="display_country_code">
                                        +{item.phonecode}
                                      </span>{" "}
                                      {item.nicename}
                                    </div>
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </div>

                        {/*Email*/}
                        <div className="contact_lable">
                          <span className="material-symbols-outlined icon-form-control">
                            alternate_email
                          </span>
                          <input
                            id="email_address"
                            name="email_address"
                            type="email"
                            className={`form-control form-control-iconpad ${
                              inquiryObj.email_address
                                ? "ng-not-empty"
                                : "ng-empty"
                            } ${
                              formSubmitted && errors.email_address
                                ? "error"
                                : ""
                            } ${
                              errors.email_address ? "ng-invalid" : "ng-valid"
                            } ${inquiryObj.email_address ? "ng-touched" : ""}`}
                            value={inquiryObj.email_address}
                            onChange={handleChange}
                            tabIndex="3"
                          />
                          <label className="md-lable" htmlFor="email_address">
                            Email
                          </label>
                          <div className="valid-icon-of-form">
                            <img
                              loading="lazy"
                              src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                              alt="valid"
                            />
                          </div>
                        </div>

                        {/* Address */}
                        <div className="form_wrapper contact_form">
                          <div className="contact_lable">
                            <span className="material-symbols-outlined icon-form-control">
                              person
                            </span>
                            <input
                              id="address"
                              name="address"
                              type="text"
                              className={`form-control form-control-iconpad ${
                                inquiryObj.address ? "ng-not-empty" : "ng-empty"
                              } ${errors.address ? "ng-invalid" : "ng-valid"} ${
                                inquiryObj.address ? "ng-touched" : ""
                              } ${
                                formSubmitted && errors.address ? "error" : ""
                              }`}
                              value={inquiryObj.address}
                              onChange={handleChange}
                              tabIndex="4"
                            />
                            <label className="md-lable" htmlFor="address">
                              Address
                            </label>
                            <div className="valid-icon-of-form">
                              <img
                                loading="lazy"
                                src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                                alt="valid"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Date Of Birth */}
                        <div className="contact_lable">
                          {
                            <div className="mdInput toggleDateFrom_input">
                              <div className="relative">
                                <input
                                  id="birth_date_display"
                                  name="birth_date_display"
                                  type="date"
                                  className={`date_picker_input form-control ${
                                    inquiryObj.birth_date_display
                                      ? "ng-not-empty"
                                      : "ng-empty"
                                  } 
                                                                    ${
                                                                      errors.birth_date_display
                                                                        ? "ng-invalid"
                                                                        : "ng-valid"
                                                                    } 
                                                                    ${
                                                                      inquiryObj.birth_date_display
                                                                        ? "ng-touched"
                                                                        : ""
                                                                    } 
                                                                    ${
                                                                      formSubmitted &&
                                                                      errors.birth_date_display
                                                                        ? "error"
                                                                        : ""
                                                                    }`}
                                  value={inquiryObj.birth_date_display}
                                  onChange={handleChange}
                                  max={todayDate}
                                  autoComplete="off"
                                  tabIndex="5"
                                  style={{ opacity: 1 }}
                                />
                                <label
                                  className="md-lable default_lable"
                                  htmlFor="birth_date_display"
                                >
                                  Date of Birth
                                </label>
                              </div>
                            </div>
                          }
                        </div>

                        {/* Company Name */}
                        <div className="form_wrapper contact_form">
                          <div className="contact_lable">
                            <span className="material-symbols-outlined icon-form-control">
                              business
                            </span>
                            <input
                              id="company_name"
                              name="company_name"
                              type="text"
                              className={`form-control form-control-iconpad ${
                                inquiryObj.company_name
                                  ? "ng-not-empty"
                                  : "ng-empty"
                              } 
                                                             ${
                                                               inquiryObj.company_name
                                                                 ? "ng-touched"
                                                                 : ""
                                                             }`}
                              value={inquiryObj.company_name}
                              onChange={handleChange}
                              tabIndex="6"
                            />
                            <label className="md-lable" htmlFor="company_name">
                              Company Name
                            </label>
                            <div className="valid-icon-of-form">
                              <img
                                loading="lazy"
                                src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                                alt="valid"
                              />
                            </div>
                          </div>
                        </div>

                        <p className="relative check_box_error get_update_text align_center">
                          <input
                            className="get_update_checkbox"
                            type="checkbox"
                            id="agree_tandc"
                            tabIndex={6}
                            name="agree_tandc"
                            aria-required="true"
                            aria-invalid="true"
                          />
                          <label
                            className="darkgray-font"
                            htmlFor="agree_tandc"
                          >
                            Keep me updated.
                          </label>
                        </p>

                        <div className="submit-button border-div-venus-wrapper submit-button-contact form_button">
                          <button
                            className="reecosys-template-button button-style-primary w100"
                            type="submit"
                            tabIndex={7}
                          >
                            {formSubmitted &&
                            Object.values(errors).every((err) => err === "") ? (
                              <span>Please Wait...</span>
                            ) : (
                              <span>Submit</span>
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
